import * as React from 'react';

export function IconData() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 80 80">
      <path fill="#0468FF" fillOpacity=".1" d="M0 16V8h24l8.5 8H64v64H0V16z" />
      <path fill="#0468FF" d="M36 32h36l8 8v40H36V32z" />
      <path
        fill="#fff"
        d="M44 42h4v4h-4zM52 43h20v2H52zM44 50h4v4h-4zM52 51h20v2H52zM44 58h4v4h-4zM52 59h20v2H52zM44 66h4v4h-4zM52 67h20v2H52z"
      />
    </svg>
  );
}
